import { motion } from "framer-motion";
import type { MotionValue } from "framer-motion";
import landscapeSkyEvening from "../../../assets/landscape-sky-evening.webp?inline";
import landscapeSky from "../../../assets/landscape-sky.webp?inline";
import { CrossfadeParallaxLayer } from "../../../shared/landscape/crossfade-parallax-layer";

type TLandscapeSkyProps = {
	y: MotionValue<number>;
	eveningOpacity: MotionValue<number>;
};

export function LandscapeSky({ y, eveningOpacity }: TLandscapeSkyProps) {
	return (
		<CrossfadeParallaxLayer
			y={y}
			eveningOpacity={eveningOpacity}
			daySrc={landscapeSky}
			eveningSrc={landscapeSkyEvening}
			className="absolute isolate z-0 pointer-events-none select-none inset-[-3%_0_0]"
			scale={1.03}
			overlay={
				<>
					<div
						className="absolute inset-0 z-[1] pointer-events-none"
						style={{
							background:
								"linear-gradient(180deg, rgba(186, 208, 218, 0.18) 0%, rgba(210, 220, 224, 0.06) 38%, transparent 58%, rgba(255, 214, 168, 0.16) 82%, rgba(255, 200, 150, 0.22) 100%)",
						}}
					/>
					<motion.div
						className="absolute inset-0 z-[2] pointer-events-none"
						style={{
							opacity: eveningOpacity,
							backgroundImage:
								"radial-gradient(circle at 73% 43%, rgba(255, 240, 232, 0.95) 0, rgba(245, 207, 205, 0.68) 31%, transparent 67%), linear-gradient(120deg, rgba(151, 164, 205, 0.88) 0%, rgba(201, 197, 218, 0.76) 48%, rgba(242, 190, 178, 0.72) 100%)",
						}}
					/>
				</>
			}
		/>
	);
}
